import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.css";
import TestimonialsData from "../data/TestimonialsData.json";

export default function Testimonials({imagesObj}) {
  console.log(imagesObj);

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", zIndex: "0" }}
        onClick={onClick}
      >
        <img
          src={process.env.PUBLIC_URL + "/images/Home/right-arrow.png"}
          style={{ width: "50px" }}
          // src="images/Home/corner-top.png"
          alt="corner"
          className=""
        />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", zIndex: "0" }}
        onClick={onClick}
      >
        <img
          src={process.env.PUBLIC_URL + "/images/Home/left-arrow.png"}
          // src="images/Home/corner-top.png"
          style={{ width: "50px" }}
          alt="corner"
          className=""
        />
      </div>
    );
  }

  const settings = {
    dots: true,
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    speed: 2000,
    autoplaySpeed: 5000,
    autoplay: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        {TestimonialsData.map((feedback) => {
          return (
            <div>
              <div className="testimonial-message-wrap">
                <div className="testimonial-message-row">
                  <img
                    src={process.env.PUBLIC_URL + "/images/Home/corner-top.png"}
                    alt="corner"
                    className="corner-top"
                  />
                  <div className="testimonial-profile-row">
                    <div className="testimonial-profile-box box1">
                      <img
                        src={imagesObj && imagesObj[feedback.image]}
                        alt="leader"
                        className="leader-imgs"
                      />
                    </div>
                    <div className="testimonial-profile-box box2">
                      <h3 className="firstname_lastname">{feedback.name}</h3>
                      <p className="designation">{feedback.designation}</p>
                    </div>
                  </div>
                  <div className="testimonial-message-box">
                    <p>{feedback.feedback}</p>
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Home/corner-bottom-old.png"
                      }
                      // src="images/Home/corner-bottom.png"
                      alt="quote"
                      className="right-quote-img"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}
